export default "__VITE_ASSET__BnUMMNnt__"